import axios from "../config/axios";
import Constants from "../data/Constants";

export const getCoursesList = async (filters = {}, pagination = {}) => {
  if (filters.type == "All") {
    filters.type = undefined;
  }

if (filters.status == "All") {
    filters.status = undefined;
  }

  return await axios
    .get(Constants.ENDPOINTS.COURSE.ALL, {
      params: {
        type:filters.type,
        status:filters.status,
      },
    })
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleCourse = async (id) => {
  return await axios.get(Constants.ENDPOINTS.COURSE.SINGLE + id).then((res) => {
    return res.data.result;
  });
};

export const getCourseReviews = async (id) => {
  return await axios.get(Constants.ENDPOINTS.COURSE.REVIEW + id).then((res) => {
    return res.data.result;
  });
};

export const createSingleCourse = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.COURSE.CREATE, data)
    .then((res) => {
      return res.data.result;
    });
};

export const updateSingleCourse = async (id, data) => {
  return await axios
    .put(Constants.ENDPOINTS.COURSE.UPDATE + id, data)
    .then((res) => {
      return res.data.result;
    });
};
